import { v4 as uuidv4 } from 'uuid';

export function MinicartProductListProductName(props = {}, childrenComponents = []) {
	return {
		componentName: 'MinicartProductListProductName',
		componentId: uuidv4(),
		props: Object.assign({}, props),
		childrenComponents,
	};
}
